import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, IconButton, makeStyles, Menu, MenuItem, Typography } from '@material-ui/core';
import { MoreVertOutlined } from '@material-ui/icons';
import { useState } from 'react';
const useStyles = makeStyles((theme) => ({
    divider: {
        margin: theme.spacing(2, 0),
    },
    headingContainer: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    menuContainer: {
        display: 'flex',
    },
    menuItemBtn: {
        padding: theme.spacing(0.83),
        '&:hover': {
            background: 'transparent',
        },
    },
    subtitle: {
        '& a': {
            color: theme.palette.primary.main,
            textDecoration: 'underline',
            '&:focus, &:hover': {
                color: theme.palette.primary.dark,
                textDecoration: 'none',
            },
        },
    },
}));
export function PageHeader({ className, contentRight, divider, id, menuItems, subtitle, title, titleVariant = 'h1', }) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = (e) => {
        setAnchorEl(e.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (_jsxs("div", { className: className && className, "data-testid": 'page-header', children: [_jsxs("div", { className: classes.headingContainer, children: [_jsxs("div", { className: classes.menuContainer, children: [title && (_jsx(Typography, { variant: titleVariant, id: id, color: 'textPrimary', children: title })), menuItems && (_jsxs(_Fragment, { children: [_jsx(IconButton, { "aria-label": 'View more information', "aria-controls": 'page-header-menu', "aria-haspopup": 'true', color: 'secondary', className: classes.menuItemBtn, disableFocusRipple: true, disableRipple: true, disableTouchRipple: true, onClick: handleClick, children: _jsx(MoreVertOutlined, { fontSize: 'small' }) }), _jsx(Menu, { anchorEl: anchorEl, anchorOrigin: { vertical: 'top', horizontal: 'right' }, id: 'page-header-menu', keepMounted: true, open: Boolean(anchorEl), onClose: handleClose, children: menuItems.map((item, index) => (_jsx(MenuItem, { onClick: item.onClick ? item.onClick : () => window.open(item.link, '_blank'), children: _jsx(Typography, { variant: 'body1', children: item.label }) }, index))) })] }))] }), contentRight && _jsx("div", { children: contentRight })] }), subtitle && (_jsx(Typography, { variant: 'body1', color: 'textSecondary', className: classes.subtitle, children: subtitle })), divider && _jsx(Divider, { className: classes.divider })] }));
}
